import React, {createContext, useMemo, useState} from 'react'
import {DateTime} from 'luxon'
import ButtonCalendarAtom from '../../@atoms/to_forms/button_calendar/button_calendar.atom'
import ButtonTimeslotAtom from '../../@atoms/to_forms/button_timeslot/button_timeslot_atom'
import DateNavAtom from '../../@atoms/to_forms/date_nav/date_nav.atom'
import DateNavChoiceAtom from '../../@atoms/to_forms/date_navchoice/date_navchoice.atom'
import DateTimeChoiceWrapperAtom from '../../@atoms/to_layout/date_time_choice_wrapper/date_time_choice_wrapper.atom'
import {StateComponentWeekProps} from '../../props_reusable'
import dateTimeSlotData from '../../data/schema/best_dates.json'
// import weekdaysStatusData from '../../data/schema/weekdays_status.json'

// creating context at component level for this component only
export const StateComponentWeek = createContext({} as StateComponentWeekProps)
// default module
const DateTimeChoiceComponent = function () {
  // store weekNow from dtnow
  //= ============================================

  const dtnow = DateTime.now()
  const [weekNow, setweekNow] = useState(dtnow)
  // step to previous week
  const weekPrevFn = (week: DateTime) => setweekNow(week.minus({weeks: 1}))
  // step to next week
  const weekNextFn = (week: DateTime) => setweekNow(week.plus({weeks: 1}))
  // Marking it to stay back on every rendering process except on some update.
  const sgwValue = useMemo(
    () => ({
      weekNow,
      weekPrevFn,
      weekNextFn,
    }),
    [weekNow],
  )

  return (
    <StateComponentWeek.Provider value={sgwValue}>
      <DateTimeChoiceWrapperAtom className="demostyled-atom">
        <DateNavChoiceAtom>
          <DateNavAtom />
          <ButtonCalendarAtom
            ap_calen_arr={[
              {
                ap_type: 'disabled',
                ap_day_short: weekNow.startOf('week').minus({days: 1})
                  .weekdayShort,
                ap_day: weekNow.startOf('week').minus({days: 1}).day,
                ap_date: weekNow
                  .startOf('week')
                  .minus({days: 1})
                  .toFormat('LL/dd/yyyy'),
              },
              {
                ap_type: 'echo',
                ap_day_short: weekNow.startOf('week').plus({days: 0})
                  .weekdayShort,
                ap_day: weekNow.startOf('week').plus({days: 0}).day,
                ap_date: weekNow
                  .startOf('week')
                  .plus({days: 0})
                  .toFormat('LL/dd/yyyy'),
              },
              {
                ap_type: 'echo',
                ap_day_short: weekNow.startOf('week').plus({days: 1})
                  .weekdayShort,
                ap_day: weekNow.startOf('week').plus({days: 1}).day,
                ap_date: weekNow
                  .startOf('week')
                  .plus({days: 1})
                  .toFormat('LL/dd/yyyy'),
              },
              {
                ap_type: 'selectable',
                ap_day_short: weekNow.startOf('week').plus({days: 2})
                  .weekdayShort,
                ap_day: weekNow.startOf('week').plus({days: 2}).day,
                ap_date: weekNow
                  .startOf('week')
                  .plus({days: 2})
                  .toFormat('LL/dd/yyyy'),
              },
              {
                ap_type: 'disabled',
                ap_day_short: weekNow.startOf('week').plus({days: 3})
                  .weekdayShort,
                ap_day: weekNow.startOf('week').plus({days: 3}).day,
                ap_date: weekNow
                  .startOf('week')
                  .plus({days: 3})
                  .toFormat('LL/dd/yyyy'),
              },
              {
                ap_type: 'selectable',
                ap_day_short: weekNow.startOf('week').plus({days: 4})
                  .weekdayShort,
                ap_day: weekNow.startOf('week').plus({days: 4}).day,
                ap_date: weekNow
                  .startOf('week')
                  .plus({days: 4})
                  .toFormat('LL/dd/yyyy'),
              },
              {
                ap_type: 'selectable',
                ap_day_short: weekNow.startOf('week').plus({days: 5})
                  .weekdayShort,
                ap_day: weekNow.startOf('week').plus({days: 5}).day,
                ap_date: weekNow
                  .startOf('week')
                  .plus({days: 5})
                  .toFormat('LL/dd/yyyy'),
              },
            ]}
          />
          <ButtonTimeslotAtom ap_data_arr={dateTimeSlotData} />
        </DateNavChoiceAtom>
      </DateTimeChoiceWrapperAtom>
    </StateComponentWeek.Provider>
  )
}

export default DateTimeChoiceComponent
